import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=df1ed268&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=df1ed268&prod&lang=less&scoped=true"
import style1 from "./OrderList.vue?vue&type=style&index=1&id=df1ed268&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1ed268",
  null
  
)

export default component.exports